import masterDetail from "../components/masterDetail.js";
import dataStructure from "../data.js";

let Users = (()=>{
    let me = {};

    me.render = async container=>{
        await masterDetail.render(container,dataStructure.users);
    }

    return me;
})();

export default  Users;